(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * 
	 * 
	 * @description
	 * 
	 */
	angular.module('paxMessage')
			.factory('PaxMessageFactory', PaxMessageFactory);

	function PaxMessageFactory() {

		function PaxMessageSearchDTO() {
			this.fromDate = null;
			this.toDate = null;
			this.flightNumber = null;
			this.countryCode = null;
			this.responseCode = null;
			this.crewStatus = null;
		}
		
		function PaxMessageOverrideDTO(){
			this.paxMsgJourneyCrewId = null;
			this.paxMsgSchdId = null;
			this.overideCode = null;
		}
		
		function resubmitDTO(){
			this.paxMsgJourneyCrewIds = [];
			this.paxMsgSchdId = null;
			this.flightLegId  = null;
			this.triggerId = null;
		}

		function GetPaxMessageSearchRequest() {
			return new PaxMessageSearchDTO();
		}

		function GetOverrideData(){
			return new PaxMessageOverrideDTO();
		}
		
		function GetResubmitRequest(){
			return new resubmitDTO();
		}

		return {
			getPaxMessageSearchRequest : GetPaxMessageSearchRequest,
			getOverrideData :GetOverrideData,
			getResubmitRequest :GetResubmitRequest
		}
	}
})();